import classNames from "classnames";
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import IconArrowRight from "@/icons/icon-arrow-right";

import linkStyles from "../editorials/editorial-link/editorial-link.module.scss";
import styles from "./button.module.scss";
import Icon from "./icon";
import LoadingDots from "./loading-dots";

export type ServiceButtonVariants = {
  variant?: "serviceBig" | "serviceMedium" | "serviceSmall";
};

export type ButtonVariants = {
  variant?: "primary" | "secondary";
};

export type ButtonProps = {
  lookAsLink?: boolean;
  loading?: boolean;
  variant?: ServiceButtonVariants["variant"] | ButtonVariants["variant"];
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export default function Button(props: ButtonProps) {
  const { variant, lookAsLink, loading, ...rest } = props;

  function calculateClasses() {
    if (lookAsLink) {
      return [linkStyles.link, linkStyles.linkMedium];
    } else if (variant) {
      return [styles.button, styles[variant]];
    } else {
      return [];
    }
  }

  return (
    <button
      {...rest}
      type={props.type ?? "button"}
      data-type={props.variant}
      className={classNames(...calculateClasses(), { [styles.loading]: loading }, props.className)}
    >
      <LoadingDots loading={loading} />
      {typeof props.children === "string" ? <span>{props.children}</span> : props.children}
      {(variant == "serviceBig" || variant == "serviceMedium") && (
        <div className={styles.iconWrapper}>
          <Icon icon={IconArrowRight} aria-hidden />
        </div>
      )}
    </button>
  );
}
